/** Arbre pilote EgoCrisis — discussion a choix (reboucle ou avance). */
export const egoCrisisChatTree = {
  startNodeId: 'intro',
  nodes: {
    intro: {
      id: 'intro',
      tutorText:
        "Bienvenue dans EgoCrisis. Je suis Nina Martin, Tech Lead du studio. Tu viens de rejoindre l'equipe en tant que Cloud Identity Admin. Identites, licences, groupes dynamiques, tenant de test, MFA — on a du pain sur la planche. Comment veux-tu commencer ?",
      choices: [
        {
          id: 'intro-ready',
          label: "Je suis pret — challenge-moi sur les identites.",
          tutorResponse: "Parfait. Montre-moi ce que tu sais vraiment, pas ce que tu as lu dans un cheat sheet.",
          advances: true,
          nextNodeId: 'jobtitle',
        },
        {
          id: 'intro-brief',
          label: "Rappelle-moi d'abord ce qu'on doit securiser.",
          tutorResponse:
            "On doit maitriser cinq leviers : metadonnees utilisateur, licence P2, groupes dynamiques, isolation par tenant, et MFA sur les comptes admin. Reviens quand tu es pret a en discuter.",
          advances: false,
          nextNodeId: 'intro',
        },
      ],
    },
    jobtitle: {
      id: 'jobtitle',
      isAssessment: true,
      tutorText:
        "Premier sujet. Pourquoi le champ jobTitle est-il important lors de la creation d'un utilisateur dans Entra ID ?",
      choices: [
        {
          id: 'jobtitle-wrong-required',
          label: "Il est requis pour creer le compte.",
          tutorResponse:
            "Non. Le compte se cree sans jobTitle. Reprends : a quoi sert une metadonnee dans une regle d'automatisation ?",
          advances: false,
          nextNodeId: 'jobtitle',
        },
        {
          id: 'jobtitle-wrong-license',
          label: "Il determine la licence assignee.",
          tutorResponse:
            "Les licences se mappent via groupes ou policies, pas directement via jobTitle. Essaie encore.",
          advances: false,
          nextNodeId: 'jobtitle',
        },
        {
          id: 'jobtitle-correct',
          label: "Il alimente les groupes dynamiques.",
          tutorResponse:
            "Exact. jobTitle est une variable dans la chaine d'automatisation — par ex. user.jobTitle -eq 'Cloud Administrator'. Ces groupes pilotent RBAC et securite.",
          advances: true,
          nextNodeId: 'licence',
        },
      ],
    },
    licence: {
      id: 'licence',
      isAssessment: true,
      tutorText:
        "Bien. Maintenant la licence : laquelle active les groupes dynamiques et le Conditional Access ?",
      choices: [
        {
          id: 'licence-free',
          label: 'Entra ID Free',
          tutorResponse: "Free ne couvre pas CA ni groupes dynamiques. Tu bloques toute l'automatisation.",
          advances: false,
          nextNodeId: 'licence',
        },
        {
          id: 'licence-p1',
          label: 'Entra ID P1',
          tutorResponse: "P1 manque des briques critiques pour notre scenario. Pousse plus loin.",
          advances: false,
          nextNodeId: 'licence',
        },
        {
          id: 'licence-p2',
          label: 'Entra ID P2',
          tutorResponse:
            "Oui. P2 debloque groupes dynamiques, Conditional Access et Identity Protection. Sans elle, on n'avance pas.",
          advances: true,
          nextNodeId: 'dynamic-group',
        },
      ],
    },
    'dynamic-group': {
      id: 'dynamic-group',
      isAssessment: true,
      tutorText:
        "Quel type de groupe utiliser pour automatiser les droits selon le jobTitle ?",
      choices: [
        {
          id: 'dg-distribution',
          label: 'Distribution group',
          tutorResponse: "Distribution = messagerie, pas securite. Recentre-toi sur les security groups.",
          advances: false,
          nextNodeId: 'dynamic-group',
        },
        {
          id: 'dg-static',
          label: 'Security group a membership statique',
          tutorResponse: "Statique = maintenance manuelle. On veut de l'automatique base sur les attributs.",
          advances: false,
          nextNodeId: 'dynamic-group',
        },
        {
          id: 'dg-dynamic',
          label: 'Security group a membership dynamique',
          tutorResponse:
            "Correct. Le groupe evalue en continu jobTitle et autres attributs — squelette structurel meme sans membre.",
          advances: true,
          nextNodeId: 'tenant',
        },
      ],
    },
    tenant: {
      id: 'tenant',
      isAssessment: true,
      tutorText:
        "Pour la R&D EgoCrisis Labs : pourquoi un tenant separe plutot qu'un simple resource group isole ?",
      choices: [
        {
          id: 'tenant-rg-enough',
          label: "Un resource group isole suffit.",
          tutorResponse:
            "RG = cloison logique. Un compte compromis peut pivoter. Le tenant, c'est une frontiere physique.",
          advances: false,
          nextNodeId: 'tenant',
        },
        {
          id: 'tenant-cheaper',
          label: 'Le tenant separe coute moins.',
          tutorResponse: "Ce n'est pas une question de cout — c'est d'isolation. Reessaie.",
          advances: false,
          nextNodeId: 'tenant',
        },
        {
          id: 'tenant-isolation',
          label: 'Isolation physique vs cloison logique',
          tutorResponse:
            "Bien vu. Tenant separe = policies, logs et terraform destroy sans risque pour la prod.",
          advances: true,
          nextNodeId: 'mfa',
        },
      ],
    },
    mfa: {
      id: 'mfa',
      isAssessment: true,
      tutorText:
        "Dernier verrou : pour la politique MFA des comptes privilegies, quelles Target resources cibler ?",
      choices: [
        {
          id: 'mfa-all-apps',
          label: 'All cloud apps',
          tutorResponse: "Trop large — tu bloques les utilisateurs standard. Scope admin uniquement.",
          advances: false,
          nextNodeId: 'mfa',
        },
        {
          id: 'mfa-azure-portal',
          label: 'Azure Portal uniquement',
          tutorResponse: "Incomplet. Il existe d'autres portails d'administration Microsoft.",
          advances: false,
          nextNodeId: 'mfa',
        },
        {
          id: 'mfa-admin-portals',
          label: 'Microsoft Admin Portals',
          tutorResponse:
            "Parfait. On protege ceux qui touchent aux roles et policies, pas les acces utilisateur classiques.",
          advances: true,
          nextNodeId: 'outro',
        },
      ],
    },
    outro: {
      id: 'outro',
      tutorText:
        "Bien joue. Tu as tenu la discussion sur les cinq piliers : identites, P2, groupes dynamiques, tenant isole, MFA admin. Le tenant est securise — l'equipe peut travailler.",
      choices: [],
      isEnd: true,
    },
  },
};
